import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadioComponent {
  @Input() checked = false;
  @Input() noContent = false;
  @Input() disabled = false;
  @Input() simple = false;
  @Input() small = false;
  @Input() flex = false;
  @Input() checkStyle: 'check' | 'radio' = 'check';
  @Input() color: string;
}
